"use client";
import { StaffReauth } from './staff-reauth';
import { useRef, useState } from "react";
import { api, commandId, reasonText, ApiError } from "../../lib/api";
import { Banner, Button, ConfirmPanel, Field, Textarea } from ".";

/** Keep the same command on an uncertain retry; changing the reason starts a new command. */
export function ConfirmedCommand<T>({ label, title, consequence, path, body = {}, reasonLabel, reasonKey = "reason", minReason = 1, onSaved, disabled = false, reauthenticate = false }: {
  label: string; title: string; consequence: string; path: string; body?: object;
  reasonKey?: string; reasonLabel?: string; minReason?: number; onSaved: (result: T) => void; reauthenticate?: boolean; disabled?: boolean;
}) {
  const [open, setOpen] = useState(false), [reason, setReason] = useState(""), [busy, setBusy] = useState(false), [error, setError] = useState("");
  const [reauth, setReauth] = useState(false);
  const lock = useRef(false), command = useRef<{ fingerprint: string; id: string } | null>(null);
  const send = async (retrying = false) => {
    if (lock.current) return;
    lock.current = true; setBusy(true); setError("");
    const payload = { ...body, ...(reasonLabel ? { [reasonKey]: reason.trim() } : {}) };
    const fingerprint = JSON.stringify({ path, payload });
    if (command.current?.fingerprint !== fingerprint) command.current = { fingerprint, id: commandId() };
    try {
      const result = await api<T>(path, { method: "POST", body: { ...payload, commandId: command.current.id } });
      setOpen(false); setReason(""); command.current = null; onSaved(result);
    } catch (caught) { if (reauthenticate && !retrying && caught instanceof ApiError && caught.reasonCode === "REAUTH_REQUIRED") { setReauth(true); return; } if (retrying) throw caught; setError(reasonText(caught)); }
    finally { lock.current = false; setBusy(false); }
  };
  return <div>
    {reauth && <StaffReauth title={label} description="填写当前账号口令后继续展屏操作。" onComplete={() => send(true)} onClose={() => { setReauth(false); if (command.current) setError("已取消身份验证，展屏状态未改变。"); }} />}
    {!open ? <Button size="sm" variant="outline" disabled={disabled} onClick={() => { setOpen(true); setError(""); }}>{label}</Button> : <ConfirmPanel title={title} consequence={consequence} confirmLabel={`确认${label}`} busy={busy} confirmDisabled={disabled || (!!reasonLabel && reason.trim().length < minReason)} onCancel={() => { setOpen(false); setError(""); }} onConfirm={() => void send()}>
      {reasonLabel && <Field label={reasonLabel}><Textarea value={reason} maxLength={500} disabled={busy} onChange={(e) => setReason(e.target.value)} /></Field>}
      {error && <Banner tone="danger">{error}</Banner>}
    </ConfirmPanel>}
  </div>;
}
